import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, map } from 'rxjs';
import { DeviceInfoService } from '../../../shared/services/device-info.service';
import { SyncClockService } from '../../../shared/services/sync-clock.service';

@Injectable({
  providedIn: 'root',
})
export class RunSheetService {
  constructor(
    private http: HttpClient,
    private deviceInfoService: DeviceInfoService,
    private clockService: SyncClockService,
  ) {}
  async createRunSheet(body?: any, params?: any) {
    body = {
      ...body,
      device_info: await this.deviceInfoService.getDeviceDetail(),
    };
    return lastValueFrom(
      this.http
        .post(`/api/run_sheet/`, body, { params: params })
        .pipe(map((response: any) => response)),
    );
  }
  getRunSheets(params?: any) {
    return this.http
      .get(`/api/run_sheet/`, { params: params })
      .pipe(map((response: any) => response));
  }
  getRunSheetDetailForDesktop(id: string, params?: any) {
    return this.http
      .get(`/api/run_sheet/${id}/`, { params: params })
      .pipe(map((response: any) => response));
  }
  getRunSheetDetailForMobile(params?: any) {
    return this.http
      .get(`/api/run_sheet/get_detail/`, { params: params })
      .pipe(map((response: any) => response));
  }

  async addRunSheetUpdates(body: any, params?: any) {
    // for service workers
    body = {
      ...body,
      updated_at: body?.updated_at || this.clockService.nowMs(),
      device_info: await this.deviceInfoService.getDeviceDetail(),
    };
    return lastValueFrom(
      this.http
        .post(`/api/run_sheet/add_update/`, body, {
          params: params,
        })
        .pipe(map((response: any) => response)),
    );
  }
  async updateRunSheet(id: string, body: any, params?: any) {
    body = {
      ...body,
      device_info: await this.deviceInfoService.getDeviceDetail(),
    };
    return lastValueFrom(
      this.http
        .put(`/api/run_sheet/${id}/`, body, {
          params: params,
        })
        .pipe(map((response: any) => response)),
    );
  }
  async getRunsheetSuggestions(requestData?: any, params?: any) {
    return lastValueFrom(
      this.http
        .post(`/api/run_sheet/get_last_unique_runsheets/`, requestData, {
          params: params,
        })
        .pipe(map((response: any) => response)),
    );
  }
  async getRunsheetAddInfo(requestData?: any, params?: any) {
    return lastValueFrom(
      this.http
        .post(`/api/run_sheet/get_runsheet_additional_info/`, requestData, {
          params: params,
        })
        .pipe(map((response: any) => response)),
    );
  }
}
